export const SERVICE_HTTP_ADDRESS = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "https://hml.api.trucoxp.com";
export const MILISECONDS_TO_FETCH_GAME_STATE = 550;
export const MAINTENENCE_MESSAGE_ON = false;

const SUPPORT_PHONE = "5516994049636";
export const SUPPORT = Object.freeze({
  phone: SUPPORT_PHONE,
  whatsappUrl: `https://wa.me/${SUPPORT_PHONE}`,
});
